import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { useEducationTooltipContext } from '../EducationTooltipContext';
import classes from './index.module.scss';

const EducationTooltipBadge = () => {
  const { variant } = useEducationTooltipContext();

  return (
    <span className={classNames(classes.badge, { [classes.variantWhite]: variant === 'white' })}>
      <I18n k="tooltip.educationTooltip.badgeText" />
    </span>
  );
};

EducationTooltipBadge.displayName = 'EducationTooltipBadge';

export default EducationTooltipBadge;
